import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'
import { change } from 'redux-form'

import {
  snackbarStateSelector,
  snackbarTypeSelector,
  snackbarMessageSelector
} from 'reduxModules/selectors/SnackbarSelectors'
import { snackbarActions } from 'reduxModules/actions/SnackbarActions'

import { EnhancedSnackbarBase } from './EnhancedSnackbar'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  open: snackbarStateSelector,
  type: snackbarTypeSelector,
  message: snackbarMessageSelector
})

const mapDispatchToProps = {
  change,
  hideSnackbar: snackbarActions.hideSnackbar
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const EnhancedSnackbar = enhance(EnhancedSnackbarBase)


// WEBPACK FOOTER //
// ./src/components/EnhancedSnackbar/index.js